import BaseModelAPI from '../BaseModelAPI';

export default class Shift extends BaseModelAPI {
	static entity = 'shift';
	static entityName = 'shift';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.sequence = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}